<span class="wp-tabs-count"
      *ngIf="count > 0"
      [textContent]="count"></span>
